import React, { useEffect, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { _$, _addClass, _removeClass } from '../../../../controllers/dom';
import { locales } from '../../../../translations/locales';
import NewSkill from '../skills/NewSkill';
import NewFunction from './NewFunction';

const listFunctions = [];
const listSkills = [];
const newFunctionSkills = [];
const newVehicleModelFunctions = [];

const NewVehicleModel = (props) => {
    const { locale, theme, ModuleRP, data } = props;
    const [update, setUpdate] = useState(new Date());

    for (let i = 0; i < data.functions.length; i++) {
        let existingFunction = false;
        for (let y = 0; y < listFunctions.length; y++) {
            const vehicleFunction = listFunctions[y];
            if (vehicleFunction.name === data.functions[i].name) {
                existingFunction = true;
            }
        }
        if (!existingFunction) {
            listFunctions.push(data.functions[i]);
        }
    }
    for (let i = 0; i < data.skills.length; i++) {
        let existingSkill = false;
        for (let y = 0; y < listSkills.length; y++) {
            const skill = listSkills[y];
            if (skill === data.skills[i]) {
                existingSkill = true;
            }
        }
        if (!existingSkill) {
            listSkills.push(data.skills[i]);
        }
    }

    const newVehicleModel = () => {
        if (!_$('vehicleModelName').value) {
            _addClass('vehicleModelName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        if (newVehicleModelFunctions.length == 0) {
            _addClass('vehicleModelFunctions', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].config.functionsInvalid);
        }
        ModuleRP.config.newVehicleModel(newVehicleModelFunctions);
        listFunctions.length = 0;
        listSkills.length = 0;
        newFunctionSkills.length = 0;
        newVehicleModelFunctions.length = 0;
    };

    const addFunction = () => {
        for (let i = 0; i < newVehicleModelFunctions.length; i++) {
            const vehicleModelFunction = newVehicleModelFunctions[i];
            if (vehicleModelFunction.name === _$('vehicleModelFunctions').value) {
                _addClass('vehicleModelFunctions', ['border', 'border-danger']);
                return NotificationManager.error(locales[locale].notifications.functionsInvalid);
            }
        }
        for (let i = 0; i < listFunctions.length; i++) {
            const vehicleModelFunction = listFunctions[i];
            if (vehicleModelFunction.name === _$('vehicleModelFunctions').value) {
                newVehicleModelFunctions.push(vehicleModelFunction);
                return setUpdate(new Date());
            }
        }
    };
    const deleteFunction = (deletedFunction) => {
        for (let i = 0; i < newVehicleModelFunctions.length; i++) {
            const vehicleModelFunction = newVehicleModelFunctions[i];
            if (deletedFunction === vehicleModelFunction.name) {
                newVehicleModelFunctions.splice(i, 1);
                return setUpdate(new Date());
            }
        }
    };

    const addNewFunction = () => {
        _addClass('btn-newFunction', 'hide');
        _removeClass('bloc-newFunction', 'hide');
    };

    useEffect(() => {
        listFunctions.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
        listSkills.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });
    }, [update]);

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].config.addNewVehicleModel}
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <form onSubmit={(event) => {
                        event.preventDefault();
                        newVehicleModel();
                    }}>
                        <div className='form-group'>
                            <label htmlFor='vehicleModelName'>
                                {locales[locale].config.vehicleModelName}
                                <span className='text-info m-1'>{locales[locale].config.required}</span>
                            </label>
                            <input type='text' id='vehicleModelName' className='form-control w-100' placeholder={locales[locale].config.vehicleModelName} />
                        </div>
                    </form>
                    <form>
                        <div className='form-group'>
                            <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                <thead>
                                    <tr>
                                        <th>{locales[locale].config.functions}</th>
                                        <th>{locales[locale].config.skills}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        newVehicleModelFunctions.map((vehicleFunction) => (
                                            <tr key={`newVehicleModelFunctions${vehicleFunction.name}`}>
                                                <td>
                                                    {vehicleFunction.name}

                                                </td>
                                                <td>
                                                    {
                                                        vehicleFunction.skills.map((skill) => (
                                                            skill.skill.split('_#')[0] + ' '
                                                        ))
                                                    }
                                                </td>
                                                <td>
                                                    <button
                                                        type='button'
                                                        className='btn btn-sm btn-danger'
                                                        onClick={() => deleteFunction(vehicleFunction.name)}
                                                    >
                                                        x
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                    {
                                        newVehicleModelFunctions.length === 0 &&
                                        <tr>
                                            <td colSpan={3}>
                                                Vous devez ajouter au minimum une fonction pour valider le modèle.
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                            <select className='form-control m-1 w-75' id='vehicleModelFunctions'>
                                {
                                    listFunctions.length === 0 &&
                                    <option>
                                        Il n&apos;existe aucune fonction de véhicule actuellement
                                    </option>
                                }
                                {
                                    listFunctions.map((vehicleFunction) =>
                                    (<option key={`listFunctions_${vehicleFunction.id}`} value={vehicleFunction.name}>
                                        {vehicleFunction.name} - ({' '}
                                        {
                                            vehicleFunction.skills.map((skill) => (
                                                skill.skill.split('_#')[0] + ' '
                                            ))
                                        }
                                        )
                                    </option>
                                    ))
                                }
                            </select>
                            {
                                listFunctions.length > 0 &&
                                <button type='button' className='btn btn-sm btn-primary' onClick={addFunction}>
                                    {locales[locale].config.add}
                                </button>
                            }
                        </div>
                    </form>
                    <div>
                        <button className='btn btn-sm btn-primary' id='btn-newFunction' onClick={addNewFunction}>
                            {locales[locale].config.createNewFunction}
                        </button>
                        <NewFunction
                            theme={theme}
                            locale={locale}
                            listFunctions={listFunctions}
                            listSkills={listSkills}
                            newFunctionSkills={newFunctionSkills}
                            setUpdate={setUpdate}
                        />
                        <NewSkill
                            locale={locale}
                            theme={theme}
                            listSkills={listSkills}
                            newFunctionSkills={newFunctionSkills}
                            setUpdate={setUpdate}
                            ModuleRP={ModuleRP}
                        />
                    </div>
                </div>
                <div className={`card-footer bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <button type='button' className='btn btn-primary float-right' id='btn-newVehicleModel' onClick={newVehicleModel}>
                        {locales[locale].config.create}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewVehicleModel;
